
const labelStyles = {
  display: 'inline-block',
  width: '25%',
  paddingRight: '8px',
}

export default {
  name: {
    type: 'text',
    label: 'Facility Name',
    required: true,
    labelStyles,
  },
  city: {
    type: 'text',
    label: 'City',
    labelStyles,
  },
  state: {
    type: 'text',
    label: 'State',
    labelStyles,
  },
  emailNotifications: {
    type: 'text',
    label: 'Zip Code',
    labelStyles,
  },
}
